export default __webpack_public_path__ + "static/sumobots-79f7dfbb6b92b98110e93093e6e19037.png";